const getCurrentYearAndMonth = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  return { currentYear, currentMonth };
};

export default getCurrentYearAndMonth;
